import gCard from "@/components/g-card/g-card.vue"
import gMenu from "@/components/g-menu/g-menu.vue"
import gDateInput from "@/components/g-date-input/g-date-input.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from '../../components/g-button/g-button.vue'
import gDataTable from "@/components/g-data-table/g-data-table.vue"
import gNavbar from "@/components/g-navbar/g-navbar.vue"

export default {
    name: 'Dashboard',
    components:{
        gDataTable,
        gForm,
        gCard,
        'g-menu': gMenu,
        'g-date-input' : gDateInput,
        'g-button' : gButton,
        'g-navbar': gNavbar
    },
    mounted () {
        this.RepresentanteId = this.$store.state.representanteSelecionadoId;
        this.UnidadeId = this.$store.state.empresaSelecionadaId;
        this.GetTotaisDashboard();
    },
    data() {
        return {
            RepresentanteId: null,
            totalPedidosPendentes: '',
            totalPedidosConcluidos: '',
            totalOrcamentosLiberados: '',
            totalOrcamentosPendentes: '',
            visibleRight: false,
            colunasDaTabelaTeste: [{field: 'brand', header: 'Marca'}, {field: 'year', header:'Ano'}], //colunas da tabela
            informacao: [
            {"brand": "Volkswagen", "year": 2012, "color": "Orange", "vin": "dsad231ff"},
            {"brand": "Audi", "year": 2011, "color": "Black", "vin": "gwregre345"},
            {"brand": "Renault", "year": 2005, "color": "Gray", "vin": "h354htr"},
            {"brand": "BMW", "year": 2003, "color": "Blue", "vin": "j6w54qgh"},
            {"brand": "Mercedes", "year": 1995, "color": "Orange", "vin": "hrtwy34"},
            {"brand": "Volvo", "year": 2005, "color": "Black", "vin": "jejtyj"},
            {"brand": "Honda", "year": 2012, "color": "Yellow", "vin": "g43gr"},
            {"brand": "Jaguar", "year": 2013, "color": "Orange", "vin": "greg34"},
            {"brand": "Ford", "year": 2000, "color": "Black", "vin": "h54hw5"},
            {"brand": "Fiat", "year": 2013, "color": "Red", "vin": "245t2s"}], //conteudo da tabela, será puxado do back
            Filtro: {
                'global': {value: null, matchMode: this.filtros.CONTAINS}, //permite buscar por colunas específicas
                'year': {value: null, matchMode: this.filtros.CONTAINS},
                'brand': {value: null, matchMode: this.filtros.CONTAINS},
              },
            FlagDashboard: true
        }
    },
    watch: {
         '$store.state.representanteSelecionadoId': function() {
            this.RepresentanteId = this.$store.state.representanteSelecionadoId;
            this.UnidadeId = this.$store.state.empresaSelecionadaId;
            this.GetTotaisDashboard();
          }
      },
    methods: {
        GetTotaisDashboard() {
            this.axios({
                method: 'get',
                url: process.env.VUE_APP_WEB_API + `Pedido/GetTotaisDashboard/${this.UnidadeId}/${this.RepresentanteId}`,
              }).then((response => {
            //   this.totalPedidosPendentes = response.data.data.totalPedidosPendentes,
            //   this.totalPedidosConcluidos = response.data.data.totalPedidosConcluido,
              this.totalOrcamentosPendentes = response.data.data.totalOrcamentosPendentes,
              this.totalOrcamentosLiberados = response.data.data.totalOrcamentosLiberados
            }
            ))
            .catch(() => {
            });
        },
        pushOrcamentoLiberado(){
            this.$router.push("/orcamentos-liberados?FlagDashboard=true")
        },
        pushPedidoEmAndamento(){
            this.$router.push(`/andamento-de-pedidos?status=2&FlagDashboard=true`)
        },
        pushOrcamentoPendente(){
            this.$router.push("/orcamentos-pendentes?FlagDashboard=true")

        },
        pushConsultaOrcamento(){
            this.$router.push(`/consultar-orcamento?status=11&FlagDashboard=true`)

        },
    }

    
}
